import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';

import ErrorGif from '../../../Assets/images/Error.gif';

// export interface TraneDragAndDropProps {
//     labels: any;
//     buildFileData?: (fileBlob: any) => void;
//     importFileUploadError: boolean;
//     importFileUploadErrorCode: string;

// }

// export interface FileBlob {
//     Name: string;
//     Data: any;
// }

// export interface FileUpload {
//     Key: any;
//     Val: string;
// }

// export interface Attachment {
//     id: number;
//     name: string;
//     size: string;
//     lastModifiedDate: string;
//     type: string;
// }

function TraneDragAndDrop(props) {

    const { labels, buildFileData = () => { }, importFileUploadError = false,
        importFileUploadErrorCode = "", } = props;

    const [fileError, setfileError] = useState([]);
    const [attachments, setAttachments] = useState(null);

    const [errorMessage, setErrorMessage] = useState("Attach file type: rdl");

    const errorMessages = {
        400: labels["BadImportedTemplate.Text"] || "The file had an issue with its formating. Please check the file and try again.",
        401: "The user does not have permission to upload the file.",
        500: "The file could not be uploaded. Please try again later.",
        501: "The file could not be uploaded. Please try again later.",
        502: "The file could not be uploaded. Please try again later.",
        503: "The file could not be uploaded. Please try again later.",
    };

    async function getBlobStringFromURL(fBlob) {
        let b = await fetch(fBlob).then((r) => r.blob());
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(b);
        });
    }

    async function generateBlobData(file) {
        let blobData = await getBlobStringFromURL(URL.createObjectURL(file));
        buildFileData(blobData);
    }

    useEffect(() => {
        if (importFileUploadError) {
            setErrorMessage(errorMessages[importFileUploadErrorCode]);
            setfileError((fileError) => [...fileError, true]);
        }
    }, [importFileUploadError]);

    const onDrop = (acceptedFiles) => {
        setAttachments(acceptedFiles);
        generateBlobData(acceptedFiles);
    }



    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // pull the file type from the file name parse to lowercase
            const type = file.name.split('.').pop();
            if (type === "rdl") {
                onDrop(file)
            } else {
                setfileError(["Invalid file type. Please upload a .rdl file."]);
                setErrorMessage("Invalid file type. Please upload a .rdl file.");
            }
        }
    };

    const handleButtonClick = () => {
        document.getElementById('fileInput').click();
    };


    return (
        <Grid
            container
            spacing={2}
            sx={{ paddingTop: "24px" }}
        >
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={2} pl={0}>
                        <Button className='btn-black' variant="contained" onClick={handleButtonClick}>
                            Browse
                        </Button>
                        <input
                            id="fileInput"
                            type="file"
                            accept=".rdl"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                    </Grid>
                    <Grid item xs={10} >
                        {attachments !== null ? (
                            <Typography variant="body1" sx={{ color: 'black', fontSize: '14px', fontStyle: 'italic', paddingLeft: '20px', paddingTop: '10px' }}>{attachments.name}</Typography>
                        ) : <Typography variant="body1" sx={{ color: 'black', fontSize: '14px', fontStyle: 'italic', paddingLeft: '20px', paddingTop: '10px' }}>{labels["NoFile.Text"] || 'No file selected'}</Typography>}

                    </Grid>

                </Grid>
                {fileError.includes(true) && (
                    <div id='errormessages' style={{ display: 'block', color: 'red', fontWeight: 'bold' }}><img src={ErrorGif} alt="Error" /> {errorMessage}</div>
                )}
            </Grid>
        </Grid>
    )
}

export default TraneDragAndDrop;